import { useCallback } from "react"
import { useAppDispatch } from "../../../../store/hooks"
import { searchArticles } from "../../../../store/knowledgeBase/thunks"
import { ClassProps } from "../../../../utility/common/props"
import { SearchArticlesInputLogic } from "../Logic"
import { SearchArticlesRequest } from "../../../../models/article"

export interface SearchArticlesInputContainerProps extends ClassProps {
    projectId: string
}

export const SearchArticlesInputContainer = (props: SearchArticlesInputContainerProps) => {
    const { className, projectId } = props
    const dispatch = useAppDispatch()

    const handleSearch = useCallback(
        (request: SearchArticlesRequest) => {
            if (projectId) {
                dispatch(searchArticles(projectId, request))
            }
        },
        [projectId, dispatch]
    )

    return <SearchArticlesInputLogic onSearch={handleSearch} className={className} />
}